<template>
  <div id="content" class="startup_page">
    <AddCommentModal :dialogVisible='dialog' @close="closeModal()" @newValueIsProposed="setNewValueComment($event)" formName="Add a comment" ></AddCommentModal>
    <div class="" v-if="!isAssess">
     <div class="all_candidates_download_zone ">
       <div class="col-12 text-center">
         <span class="title">YOUR OWN CANDIDATES</span>
         <div class="row mt20">
             <span class="pool_subtitle mb10">Step 1</span><br/>
           <a href="/doc/example_import.xlsx" target="_blank" download>Download and complete our template file in Excel format</a>
                <a href="/doc/example_import.csv" target="_blank" download>Download and complete our template file in CSV format</a>

         </div>
         <div class="row mt20">
           <span class="pool_subtitle mb10">Step 2</span>
           <LongListUploader :dialogVisible='dialogFullSetFile' @close="dialogFullSetFile=false" @fileUploaded="setLongList()"  :search_field="this.$route.params.search_field"></LongListUploader>
         </div>
         <!-- <label type="button" name="button" class="next_step_btn" >
           <input
                   ref="image"
                   type="file"
                   style="display: none"
                   @change="uploadPool"
                   multiple
                 />
           <img :src="require('@/assets/greyDownload.svg')" alt="" class="left goFullWhite">
           UPLOAD YOUR CANDIDATE SELECTION
         </label> -->


       </div>
     </div>
   </div>


      <div class="content_div stats">


        <div class="row " >
          <h2 class="customH2 text-center">Your innovator pool
          <span v-if="sfname"><br/>for {{sfname}}</span></h2>
          <div class="col-12 mt50">
            <vue-collapsible-panel-group base-color="#3783C5">
                <vue-collapsible-panel>
                    <template #title>
                            <h2 class="customH2">Filters</h2>
                    </template>
                    <template #content>

                            <div class="filtre_list">
                              <div v-for="(filtre,f) in filtres" :key="f">
                                  <label class="checkbox">
                                      <input class="checkbox__input" type="checkbox" v-model="selected_filters" :value="filtre._id.$oid"/>
                                      <svg class="checkbox__icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 22">
                                        <rect width="21" height="21" x=".5" y=".5" fill="#FFF" stroke="#3783C5" rx="3" />
                                        <path class="tick" stroke="#3783C5" fill="none" stroke-linecap="round" stroke-width="4" d="M4 10l5 5 9-9" />
                                      </svg>
                                      <span class="checkbox__label">{{filtre.filter_name}}</span>
                                    </label>

                              </div>


                        </div>
                        <button type="button" @click="apply_filter()" class="next_step_btn_small" name="button">Apply filters</button>


                        <router-link class="prev_step_btn_small goToRight" :to="'/list_filters'"><small>Edit my filters</small></router-link>


                    </template>
                </vue-collapsible-panel>
            </vue-collapsible-panel-group>
          </div>


          <div class="col-12 startup_selection_section">
            <div class="loaderInnopearl " v-if="loading">
              <div class="loaderInnopearlInner">
                <img :src="require('@/assets/loaderInnopearl.svg')" alt="">
                <span>Loading in progress</span>
              </div>

            </div>
              <div class="" v-if="startups">
                <div class="col-12 text-right graph_view">
                  <router-link class="prev_step_btn_small" v-if="selected_filters.length > 0" :to="'/startup_with_filters_graph/'+this.$route.params.search_field+'/'+JSON.stringify(selected_filters)+'/'+this.$route.params.pid">Graph view</router-link>
                  <router-link class="prev_step_btn_small" v-if='to_compare.length == 2 || to_compare.length == 3' :to="'/compare_startup_to_assess/'+this.$route.params.search_field+'/'+to_compare[0]+'/'+to_compare[1]+'/'+to_compare[2]">Compare</router-link>
                  <button type="button" class="prev_step_btn_small" v-if='to_assess.length > 0'  name="button" @click="generateAssessment" :disabled="to_assess.length == 0">Assess selected innovators</button>

                </div>

                <div class="row zone">
                  <div class="col-12 col-xl-2 startup_zone_legend" :class="{ 'stickit': startups.high.length > 3 }">
                    <div class="legend" >

                    <span class="zone_title">&GreaterEqual;80% match</span>
                    <span class="zone_number">{{startups.high.length}} innovator<span v-if="startups.high.length > 1">s</span></span>
                    <button type="button" name="button" @click="selectAll('high');" class="selectAll" v-if="!isAsses && startups.high.length > 1 && allHigh == false">Select all</button>
                    <button type="button" name="button" @click="unselectAll('high');" class="selectAll" v-if="!isAsses && startups.high.length > 1 && allHigh == true">Unselect all</button>
                  </div>
                  </div>
                  <div class="col-12 col-xl-10 zone_startups">
                    <div class="row" v-if="startups.high.length > 0">
                      <div class="col-12 col-md-6 col-xl-4 candidate" v-for="(candidate, c) in startups.high" :key="c">
                        <div class="candidate_card">

                          <router-link :to="'/startup/'+candidate._id.$oid"  v-if="candidate._id" >
                            <img :src="this.apiUrl+'/get_image/'+candidate.image.$oid+'?token='+$store.state.innotoken" class="candidate_image" alt="" v-if="candidate.image">
                            <img src="https://www.innopearl.ch/wp-content/uploads/2022/12/inn_header-accelerator.jpg" class="candidate_image" alt="" v-else>
                            </router-link>
                        <div class="candidate_info_content">
                                  <router-link :to="'/startup/'+candidate._id.$oid"  v-if="candidate._id" >    <span class="candidate_name">{{candidate.name}}</span>  </router-link>
                          <span class="candidate_desc">Match score: {{candidate.percent_score.toFixed()}}%</span>
                        </div>
                        <div class="row candidate_links">
                          <div class="details">
                              <router-link :to="'/startup/'+candidate._id.$oid"  v-if="candidate._id" ><img :src="require('@/assets/eye.svg')" alt="" class="left">
                              Details
                              </router-link>
                          </div>
                          <div class="selectIt">
                            <label><span>Compare </span>  <input class=""  type="checkbox" v-model="to_compare" :value="candidate._id.$oid"/></label>
                          </div>

                        </div>
                        <div class="candidate_links candidate_comments" style="">
                          <div >


                          <small>Comment<span v-if="candidate.comments.length > 1">s</span></small>
                          <div class="comments_list">
                              <div class="one_comment" v-for="(comment, i) in candidate.comments" :key="i">
                                <span v-if="comment.value"> <strong v-if="comment.by">{{comment.by}} : </strong><span v-html="comment.value"></span></span>
                                    <span v-else>{{comment}}</span>
                              </div>

                          </div>
                              </div>
                          <div class="add_comment col-12 text-right">
                              <button type="button" class="add_new_comment" @click='openModal(candidate)' name="button">
                                <img :src="require('@/assets/comments.svg')" alt="">
                                Add a comment</button>
                          </div>
                        </div>
                        <div class="row candidate_links links_2" >
                            <div class="selectIt selectIt_fw" v-if='candidate.isAssess != true && !isAssess'>
                              <label> <input class="" type="checkbox" v-model="to_assess" :value="candidate"/> <span>Select for assessment </span> </label>
                            </div>
                            <div class="selectIt selectIt_fw" v-if='candidate.isAssess == true'>
                              <label class="text-center"> <span >Candidate already assessed</span> </label>
                            </div>


                        </div>

                              </div>
                      </div>
                    </div>
                    <div v-else>
                      <div class="alert alert-warning mt30" v-if="!loading">
                          No innovators
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row zone">
                  <div class="col-12 col-xl-2 startup_zone_legend" :class="{ 'stickit': startups.medium.length > 3 }">
                      <div class="legend" >
                    <span class="zone_title">&GreaterEqual;50% &lt;80% match</span>
                    <span class="zone_number">{{startups.medium.length}} innovator<span v-if="startups.medium.length > 1">s</span></span>
                    <button type="button" name="button" @click="selectAll('medium');" class="selectAll" v-if="!isAsses && startups.medium.length > 1 && allMedium == false">Select all</button>
                    <button type="button" name="button" @click="unselectAll('medium');" class="selectAll" v-if="!isAsses && startups.medium.length > 1 && allMedium == true">Unselect all</button>

                  </div>
                  </div>

                  <div class="col-12 col-xl-10">
                    <div class="row" v-if="startups.medium.length > 0">
                      <div class="col-12 col-md-6 col-xl-4 candidate" v-for="(candidate, c) in startups.medium" :key="c">
                        <div class="candidate_card">

                          <router-link :to="'/startup/'+candidate._id.$oid"  v-if="candidate._id" >
                            <img :src="this.apiUrl+'/get_image/'+candidate.image.$oid+'?token='+$store.state.innotoken" class="candidate_image" alt="" v-if="candidate.image">
                            <img src="https://www.innopearl.ch/wp-content/uploads/2022/12/inn_header-accelerator.jpg" class="candidate_image" alt="" v-else>
                            </router-link>
                        <div class="candidate_info_content">
                                  <router-link :to="'/startup/'+candidate._id.$oid"  v-if="candidate._id" >    <span class="candidate_name">{{candidate.name}}</span>  </router-link>
                          <span class="candidate_desc">Match score: {{candidate.percent_score.toFixed()}}%</span>
                        </div>
                        <div class="row candidate_links">
                          <div class="details">
                              <router-link :to="'/startup/'+candidate._id.$oid"  v-if="candidate._id" ><img :src="require('@/assets/eye.svg')" alt="" class="left">
                              Details
                              </router-link>
                          </div>
                          <div class="selectIt">
                            <label><span>Compare </span>  <input class="" type="checkbox" v-model="to_compare" :value="candidate._id.$oid"/></label>
                          </div>
                        </div>

                        <div class="row candidate_links links_2">
                            <div class="selectIt selectIt_fw" v-if='candidate.isAssess != true && !isAssess '>
                              <label> <input class="" type="checkbox" v-model="to_assess" :value="candidate"/> <span>Select for assessment </span> </label>
                            </div>
                            <div class="selectIt selectIt_fw" v-if='candidate.isAssess == true'>
                              <label class="text-center"> <span >Candidate already in your assessment</span> </label>
                            </div>

                        </div>



                              </div>
                      </div>
                    </div>
                    <div v-else>
                      <div class="alert alert-warning mt30" v-if="!loading">
                          No innovators
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row zone">
                  <div class="col-12 col-xl-2 startup_zone_legend"  :class="{ 'stickit': startups.low.length > 3 }">
                      <div class="legend">
                    <span class="zone_title"> &lt;50% match</span>
                    <span class="zone_number">{{startups.low.length}} innovator<span v-if="startups.low.length > 1">s</span></span>
                    <button type="button" name="button" @click="selectAll('low');" class="selectAll" v-if="!isAsses && startups.low.length > 1 && allLow == false">Select all</button>
                    <button type="button" name="button" @click="unselectAll('low');" class="selectAll" v-if="!isAsses && startups.low.length > 1 && allLow == true">Unselect all</button>

                  </div>
                  </div>

                  <div class="col-12 col-xl-10">
                    <div class="row" v-if="startups.low.length > 0">
                      <div class="col-12 col-md-6 col-xl-4 candidate" v-for="(candidate, c) in startups.low" :key="c" >
                        <div class="candidate_card">

                          <router-link :to="'/startup/'+candidate._id.$oid"  v-if="candidate._id" >
                            <img :src="this.apiUrl+'/get_image/'+candidate.image.$oid+'?token='+$store.state.innotoken" class="candidate_image" alt="" v-if="candidate.image">
                            <img src="https://www.innopearl.ch/wp-content/uploads/2022/12/inn_header-accelerator.jpg" class="candidate_image" alt="" v-else>
                            </router-link>
                        <div class="candidate_info_content">
                                  <router-link :to="'/startup/'+candidate._id.$oid"  v-if="candidate._id" >    <span class="candidate_name">{{candidate.name}}</span>  </router-link>
                            <span class="candidate_desc">Match score: {{candidate.percent_score.toFixed()}}%</span>
                        </div>
                        <div class="row candidate_links">
                          <div class="details">
                              <router-link :to="'/startup/'+candidate._id.$oid"  v-if="candidate._id" ><img :src="require('@/assets/eye.svg')" alt="" class="left">
                              Details
                              </router-link>
                          </div>
                          <div class="selectIt">
                            <label><span>Compare </span>  <input class="" type="checkbox" v-model="to_compare" :value="candidate._id.$oid"/></label>
                          </div>


                        </div>
                        <div class="row candidate_links links_2">
                            <div class="selectIt selectIt_fw" v-if='candidate.isAssess != true && !isAssess '>
                              <label> <input class="" type="checkbox" v-model="to_assess" :value="candidate"/> <span>Select for assessment </span> </label>
                            </div>
                            <div class="selectIt selectIt_fw" v-if='candidate.isAssess == true'>
                              <label class="text-center"> <span >Candidate already assessed</span> </label>
                            </div>


                        </div>

                              </div>
                      </div>

                    </div>
                    <div v-else>
                      <div class="alert alert-warning mt30" v-if="!loading">
                          No innovators
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="mt50" v-else>
                <div class="alert alert-warning text-center mt50" v-if="!loading">
                    No innovators available
                </div>
              </div>

          </div>
        </div>


      </div>
  </div>
</template>
<script>
import api from '../tools/api';
// import { debounce } from 'lodash';
 import AddCommentModal from '@/components/modals/addComment.vue'
import {
  VueCollapsiblePanelGroup,
  VueCollapsiblePanel,
} from '@dafcoe/vue-collapsible-panel'
import '@dafcoe/vue-collapsible-panel/dist/vue-collapsible-panel.css'
  import { toast } from 'vue-sonner'
  import LongListUploader from '@/components/LongListUploader.vue'
export default {
  components: {
    VueCollapsiblePanelGroup,
    VueCollapsiblePanel,
    AddCommentModal,
    LongListUploader
  },
  name: 'StartupsStatsListSpace',
  data() {
    return {
      pageInfo: {
        mainTitle : " ",
        subTitle : " ",
      },
      apiUrl: process.env.VUE_APP_API_URL,
      allHigh : false,
      allMedium : false,
      allLow : false,
      sfname: "",
      dialog :false,
      startups : null,
      filtres: [],
      selected_filters: [],
      to_compare: [],
      to_assess: [],
      isAssess:false,
      candidateForComments: null,
    }
  },
  methods:{
    setLongList(){
      this.dialogFullSetFile = false;
      this.apply_filter();
    },
    apply_filter(){
      this.loading =true;
      console.log(this.$route.params.search_field);
      api.post(process.env.VUE_APP_API_URL+"/test_filter_multiple",
          {
              fids: this.selected_filters,
              search_field: this.$route.params.search_field
          },
          {
            headers: {
                'Content-Type': 'application/json',
          }
        }).then( (r) => {
        console.log(r.data);
        this.loading =false;
        this.startups = r.data;
      });
    },
    openModal(candidate){
      this.candidateForComments = candidate;
      this.candidateForComments.assigned_pool = candidate.pool;
      this.dialog = true;
    },

    closeModal(){
      this.candidateForComments = "";

      this.dialog = false;
    },
    setNewValueComment(v){
      if(v){
        api.post(process.env.VUE_APP_API_URL+"/restrict/search_field/candidate/add_comment",
        {
          comment : v,
          candidate : this.candidateForComments,
        },
        {
          headers: {
              'Content-Type': 'application/json',
        }
      }).then( (r) => {
        console.log(r);
        toast.success("Your comment is added");
          this.candidateForComments.comments.push(r.data);
          this.candidateForComments = null;
      }).catch( () => {
          this.candidateForComments = null;
          toast.error("Oops! Something went wrong. Please try again or Contact us if problem persists. ")
      });

      }

      this.dialog = false;
    },
    unselectAll(niveau){
      console.log(niveau);
      if(niveau == "high"){
        this.startups.high.forEach((s) => {
            if(!s.isAssess){
              // if(!this.to_assess.contains(s)){
              //   this.to_assess.push(s);
              // }
              const isFound = this.to_assess.some(element => {
                if (element == s) {
                  return true;
                }

                return false;
              });
              if(isFound){
                const index = this.to_assess.indexOf(s);
                this.to_assess.splice(index,1);
              }
            }
        });
        this.allHigh = false;
      }
      if(niveau == "medium"){
        this.startups.medium.forEach((s) => {
            if(!s.isAssess){
              // if(!this.to_assess.contains(s)){
              //   this.to_assess.push(s);
              // }
              const isFound = this.to_assess.some(element => {
                if (element == s) {
                  return true;
                }

                return false;
              });
              if(isFound){
                const index = this.to_assess.indexOf(s);
                this.to_assess.splice(index,1);
              }
            }
        });
        this.allMedium = false;
      }
      if(niveau == "low"){
        this.startups.low.forEach((s) => {
            if(!s.isAssess){
              // if(!this.to_assess.contains(s)){
              //   this.to_assess.push(s);
              // }
              const isFound = this.to_assess.some(element => {
                if (element == s) {
                  return true;
                }

                return false;
              });
              if(isFound){
                const index = this.to_assess.indexOf(s);
                this.to_assess.splice(index,1);
              }
            }
        });
        this.allLow = false;
      }
    },
    selectAll(niveau){
      console.log(niveau);
      if(niveau == "high"){
        this.startups.high.forEach((s) => {
            if(!s.isAssess){
              // if(!this.to_assess.contains(s)){
              //   this.to_assess.push(s);
              // }
              const isFound = this.to_assess.some(element => {
                if (element == s) {
                  return true;
                }

                return false;
              });
              if(!isFound)this.to_assess.push(s);
            }
        });
        this.allHigh = true;
      }
      else if(niveau == "medium"){
        this.startups.medium.forEach((s) => {
            if(!s.isAssess){
              // if(!this.to_assess.contains(s)){
              //   this.to_assess.push(s);
              // }
              const isFound = this.to_assess.some(element => {
                if (element == s) {
                  return true;
                }

                return false;
              });
              if(!isFound)this.to_assess.push(s);
            }
        });
          this.allMedium = true;
      }
      else if(niveau == "low"){
        this.startups.low.forEach((s) => {
            if(!s.isAssess){
              // if(!this.to_assess.contains(s)){
              //   this.to_assess.push(s);
              // }
              const isFound = this.to_assess.some(element => {
                if (element == s) {
                  return true;
                }

                return false;
              });
              if(!isFound)this.to_assess.push(s);
            }
        });
          this.allLow = true;
      }

    },
    generateAssessment(){
      console.log(this.to_assess);

      ///restrict/search_field/generate_new_assessment/{searchfield}

      api.post(process.env.VUE_APP_API_URL+"/restrict/search_field/generate_new_assessment/"+this.$route.params.search_field,
          {
              candidates: this.to_assess
          },
          {
            headers: {
                'Content-Type': 'application/json',
          }
        }).then( (r) => {
          console.log(r.data);
          toast.success("New assessment have been asked to Innopearl Team");
          this.to_compare = [];
          this.to_assess = [];
          this.apply_filter();
        }).catch( (e) => {
          console.log(e);
            toast.error("Oops! Something went wrong. Please try again or Contact us if problem persists. ")
        });
    }
  },
  mounted(){
    this.loading =true;
    if(localStorage.getItem('currentFilterSet')){
      var fromCookie = JSON.parse(localStorage.getItem('currentFilterSet'));
      this.selected_filters = fromCookie;
    }
    console.log(this.selected_filters);
     this.$store.commit('UPDATE_PAGE_INFO',this.pageInfo);
     api.get(process.env.VUE_APP_API_URL+"/restrict/my_filters").then( (r) =>{
       this.filtres = r.data;
       api.post(process.env.VUE_APP_API_URL+"/test_filter_multiple",
           {
               fids: this.selected_filters,
               search_field: this.$route.params.search_field
           },
           {
             headers: {
                 'Content-Type': 'application/json',
           }
         }).then( (r) => {
         console.log(r.data);
         this.startups = r.data;

         api.get(process.env.VUE_APP_API_URL+"/search_field/isAssess/"+this.$route.params.search_field).then( (r) => {
           console.log("IS ASSESS");
           console.log(r.data);
           this.isAssess = r.data.isAssess;
           this.sfname = r.data.name;
           this.loading =false;
         }).catch( (e) => {console.log(e);this.loading=false;});
       }).catch( (e) => {console.log(e);this.loading=false;});
     });


  },
  watch: {
     selected_filters: function (v) {
       // Set the value in a cookie every time the variable changes
       localStorage.setItem('currentFilterSet', JSON.stringify(v));
     },
   },

}
</script>
<style scoped>

.startup_page{
  padding-top:50px;
  padding-bottom: 50px;
  padding: 50px;
}
.content_div{
  /* margin-top:50px;
  margin-bottom: 50px; */
  padding: 50px;
  background: #FFFFFF 0% 0% no-repeat padding-box;
box-shadow: 0px 3px 6px #00000029;
border-radius: 8px;
}
.chart-container {
  position: relative;
}

.next_step_btn,
.next_step_btn:hover{
  background: #3783C5 0% 0% no-repeat padding-box !important;
  box-shadow: 0px 3px 6px #00000029 !important;
  border: 1px solid #3783C5 !important;
  border-radius: 50px;
  opacity: 1;
  padding: 14px 37px;
  color:#FFF;
  margin:5px;
}

.prev_step_btn,
.prev_step_btn:hover{
  border: 1px solid #3783C5;
  border-radius: 50px;
  opacity: 1;
  padding: 14px 37px;
  color:#3783C5;
    margin:5px;
    text-decoration: none;
}

.canvasjs-chart-credit{
  display:none;
}

.mt50{
  margin-top:50px;
}

.candidate{
  margin-top:20px;
  margin-bottom: 20px;
}
.candidate_card{
  border: 1px solid #DDDDDD;
border-radius: 10px;
z-index: 5;
height:100%;
display: flex;
flex-direction: column;
}
.candidate_card .candidate_image{
  width:100%;
  height:200px;
  object-fit: cover;
  z-index: 1;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}
.candidate_card .candidate_info_content{
  padding:20px;
  border-bottom: 1px solid #DDDDDD;
}

.candidate_card .candidate_links{
  display:flex;
  flex-direction: row;
  flex-wrap: wrap;
  padding: 20px 5px;

  margin: 0;
}
.candidate_card .candidate_info_content .candidate_name{
  font-size:18px;
  line-height:21px;
letter-spacing: 0px;
color: #3783C5;
text-transform: uppercase;
display:block;
font-weight: 500;
}

.candidate_card .candidate_info_content .candidate_desc{
  font-size:16px;
  line-height:22px;
  margin-top:10px;
  display:block;
  margin-bottom:10px;
}
.candidate_card .candidate_links .details{
  font-size:12px;
  line-height: 15px;
  border-right: 1px solid #DDD;
  display:flex;
  align-items: center;
  text-transform: uppercase;
  color: #3783C5;
  flex: 0.5;

}
.candidate_card .candidate_links .details a{
    text-decoration: none;
}
.candidate_card .candidate_links .details img{
  margin-right:5px;
}
.candidate_card .candidate_links .selectIt{
  font-size:12px;
  line-height: 15px;
  letter-spacing: 0px;
  color: #3783C5;
  text-transform: uppercase;
  flex:0.5;
  align-items: flex-end;

}
.candidate_card .candidate_links .selectIt_fw{
  flex:1;
  align-items: flex-start;
}
.candidate_card .candidate_links .selectIt_fw label{
display:flex;
align-items: center;
gap: 5px;
justify-content: start;
}
.candidate_card .candidate_links .selectIt label{
display:flex;
align-items: center;
gap: 5px;
justify-content: end;
}
.candidate_card .candidate_links .selectIt input{
  width:24px;
  height:24px;
}
.candidate_card .candidate_links .details.noBorder{
  border-right: none;

}


.titre{
  margin-bottom: 20px;
  color: #3783C5;
  text-transform: uppercase;
}


.checkbox {
  cursor: pointer;
  display: flex;
  align-items: center;
  margin-bottom:20px;
}
.checkbox__input {
  position: absolute;
  width: 1.375em;
  height: 1.375em;
  opacity: 0;
  cursor: pointer;
}
.checkbox__input:checked + .checkbox__icon .tick {
  stroke-dashoffset: 0;
}
.checkbox__icon {
  width: 1.375em;
  height: 1.375em;
  flex-shrink: 0;
  overflow: visible;
}
.checkbox__icon .tick {
  stroke-dasharray: 20px;
  stroke-dashoffset: 20px;
  transition: stroke-dashoffset 0.2s ease-out;
}
.checkbox__label {
  margin-left: 0.5em;
}

.filtres{

  padding:0;
}
.filtres_head .customH2{
  display: block;
  width: 100%;
  background: #3783C5;
  color: #FFF;
  padding: 10px;
}
.filtre_list{
  padding:10px;
}

.graph_view{
  position: sticky;
    right: 0;
    top: 0;
    background: #FFF;
    padding: 20px 0px;
    z-index:999;

}
.prev_step_btn_small{
  border: 1px solid #3783C5;
  border-radius: 50px;
  opacity: 1;
  padding: 5px 20px;
  color:#3783C5;
    margin:5px;
    text-decoration: none;
}

.next_step_btn_small, .next_step_btn_small:hover {
  background: #3783C5 0% 0% no-repeat padding-box !important;
  box-shadow: 0px 3px 6px #00000029 !important;
  border: 1px solid #3783C5 !important;
  border-radius: 50px;
  opacity: 1;
  padding: 5px 20px;
  color: #FFF;
  margin: auto;
  display:block;
  margin-top:20px;
  margin-bottom: 20px;
}
.startup_zone_legend{
  align-self: top;
}
.zone_startups{
    align-self: center;
}
.zone_title{
  font-size: 25px;
  color: #3783C5;
  font-weight: 700;
  text-align: center;
  display:block;
  width:100%;
  text-align:center;

}
.zone_number{
  font-size: 16px;
  color: #3783C5;
  font-weight: 700;
  text-align: center;
  display:block;
  width:100%;
  text-align:center;

}

.row.zone{
  padding-bottom: 50px;
  padding-top:50px;
  border-bottom: 2px dashed #CCC;
}

.startup_zone_legend.stickit .legend{
  position: sticky;
    top: 50%; /* Adjust the top value as needed */
}

.startup_zone_legend:not(.stickit){
  align-self: center;
}

.alert{
  margin:0;
}



.startup_selection_section{
  position:relative;
  padding-top:50px;
}

.filtre_list{
  display: grid;
    grid-template-columns: auto auto auto;
    grid-template-columns: 1fr 1fr 1fr;
    grid-auto-rows: 100%;
    gap:10px;
}


@media screen and (max-width: 690px){
  .candidate_card .candidate_links{
    flex-direction: column;
    flex-wrap: wrap;
    gap: 20px
  }
  .candidate_pool{
      padding: 20px;
    }
    .candidate_card .candidate_links .details{
      border-right: none;
      border-bottom:1px solid #DDD;
      padding-bottom: 20px;
    }
    .candidate_card .candidate_links .selectIt label{
    display:flex;
    align-items: center;
    gap: 5px;
    justify-content: start;
    flex-direction: row-reverse;
    }
    .filtre_list {
  display: grid;
  grid-template-columns: auto auto auto;
  grid-template-columns: 1fr;
  grid-auto-rows: 100%;
  gap: 10px;
}
}


.candidate_comments{
  padding: 20px 50px;
  border-top: 1px solid #DDD;
  margin-top:auto;
}
.candidate_comments .one_comment{
  margin-top:10px;
  margin-bottom: 10px;
  font-size:12px;
  line-height:15px;
    position:relative;
}
.candidate_comments .one_comment:after {
  content: ""; /* This is necessary for the pseudo element to work. */
     display: block; /* This will put the pseudo element on its own line. */
     margin: 0 ; /* This will center the border. */
     width: 20%; /* Change this to whatever width you want. */
     padding-top: 10px; /* This creates some space between the element and the border. */

     border-bottom: 1px solid #CCC; /* This creates the border. Replace black with whatever color you want. */
}
.candidate_comments small{
  font-size:12px;
}

.add_new_comment{
  font-size:12px;
  line-height:15px;
  color: #3785C5;
  text-transform: uppercase;
  margin-top:20px;
}
.add_new_comment img{
  width: 20px;
  margin-right: 10px;
}


.all_candidates_download_zone{
    padding: 50px;
    background: #FFF;
    background: #FFFFFF 0% 0% no-repeat padding-box;
box-shadow: 0px 3px 6px #00000029;
border-radius: 8px;
margin-bottom:50px;
}


.title{
  font-size: 24px;
  line-height:29px;
letter-spacing: 0px;
color: #3783C5;
text-transform: uppercase;
display:block;
margin-bottom: 10px;
}



.all_candidates_download_zone .description{
  display:block;
  margin-top:10px;
  margin-bottom: 20px;
  width:100%;
}

.next_step_btn{
  background: #3783C5 0% 0% no-repeat padding-box;
  box-shadow: 0px 3px 6px #00000029;
  border: 1px solid #3783C5;
  border-radius: 50px;
  opacity: 1;
  padding: 14px 37px;
  color:#FFF;
  margin:5px;
}
.next_step_btn img.left{
  margin-right:10px;
}
img.goFullWhite{
filter: brightness(0) invert(1);
}

.pool_subtitle{
  font-size: 24px;
  line-height:29px;
letter-spacing: 0px;
color: #3783C5;
display:block;
}
.mb10{
  margin-bottom:10px;
}
.mt20{
  margin-top:20px;
}
</style>
<style media="screen">
  .vcp__header{
    background-color:#3783C5 !important;
    color:#FFF !important;
    padding:20px !important;
  }
  .vcp__body {
 border-top: 1px solid #3783C5 !important;
}
.vcpg{
   border: 1px solid #3783C5 !important;
}
  .vcp__header .customH2{
    font-size:20px;
    line-height:20px;
    margin:0;
  }

  .links_2{
    border-top: 1px solid #DDD;
  }
  .mt30{
    margin-top:30px;
  }
.selectAll{
  border: 1px solid #CCC;
  border-radius: 50px;
  padding: 5px 20px;
  margin: auto;
    margin-top: auto;
  display: block;
  margin-top: 20px;
}
.goToRight{

}

</style>
